module.exports = __webpack_public_path__ + "img/03.860bed7c.jpg";